import { Component, OnInit,HostListener,ViewChild,Inject } from '@angular/core';
import { Http,Headers, Response } from '@angular/http';
import { HelperService } from '../helper.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserIdleService } from 'angular-user-idle';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [HelperService]
})
export class DashboardComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
   dtOptions: DataTables.Settings = {};
   dtOptions2: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();
   dtElement: DataTableDirective;
  user_permissions:any=[];
  subscription="0";
  parents="0";
  topic_vedio="0";
  payment="0";
  data:any=[];
  enquirys:any=[];
  doubts:any=[];
  recent_chats:any=[];
  todaysubscription;
  todays_offline_subscription;
  todays_online_subscription;
  pending_offline_subscription;
  pendingOrders;
  newOrders;
  processingOrders;
  currentDate;
  checkIfTeacher;
  newenquiries;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
  });
  public modalRef: BsModalRef;
  @ViewChild('childModal') childModal: ModalDirective;
  isPopupVisible=false;

  constructor(private helper:HelperService,private cookie:CookieService,private snackbar: MatSnackBar,private http:Http,private activatedRouter:ActivatedRoute,private router:Router,private userIdle: UserIdleService,private modalService: BsModalService,public dialog: MatDialog) { }

  ngOnInit() {

    // this.userIdle.startWatching();

    // // Start watching when user idle is starting.
    // this.userIdle.onTimerStart().subscribe(count =>
    //    console.log(count)
    //    );

    // // Start watch when time is up.
    // this.userIdle.onTimeout().subscribe(() =>{
    //   //alert("time up");
    //   const dialogRef = this.dialog.open(ExpiredDialogBox, {
    //     height: '350px',
    //      width: '1000px',
    //      disableClose: true
    //   });

    //   dialogRef.afterClosed().subscribe(result => {

    //   });
    //   // this.isPopupVisible = true;
    //   //  this.childModal.show();

    //     //   this.cookie.removeAll();
    //     // localStorage.removeItem('access_token');
    //     // localStorage.removeItem('navigateroute');
    //     //   console.log('Time is up!');
    //     //   this.snackbar.open("Session Has Expired,Please Login Again", null, {
    //     //     duration:5000,
    //     //       extraClasses:'error-snackbar',
    //     //       verticalPosition:'top'
    //     //     });
    //     //   this.router.navigate(['login/'])
    //     //   .then(() => {
    //     //     window.location.reload();
    //     //   });
    // });
    this.snackbar.open('Welcome', null, {
      duration:5000,
        extraClasses:'success-snackbar',
        verticalPosition:'top'
      });
    //alert("in");
    this.currentDate = new Date();

    //let headers = new Headers({ 'Authorization': user_token });

    //alert(this.currentDate);
    this.http.get(this.helper.base_url+'http/dashboard',{ headers: this.headers })

    .subscribe(data => {
    //this.data=JSON.parse(data['_body']).data;
    this.data = JSON.parse(data['_body']);
    if(this.data.data.status != "error")
    {
      if(this.data.data[0].subscription!=0){
        //console.log(this.data.data[0]);
        this.subscription=this.data.data[0].subscription;
      }

      if(this.data.data[0].parents!=0){
        this.parents=this.data.data[0].parents;
      }

      if(this.data.data[0].payment!=0){
        this.payment=this.data.data[0].payment;
      }
      //if(this.data[0].todays_subscription){
        this.todaysubscription =this.data.data[0].todays_subscription;
      //}
      //alert(this.data[0].todays_online_subscription);
      //if(this.data[0].todays_online_subscription){
        this.todays_online_subscription =this.data.data[0].todays_online_subscription;

      //}
      // if(this.data[0].todays_offline_subscription){
        this.todays_offline_subscription =this.data.data[0].todays_offline_subscription;
      //}
      this.pending_offline_subscription =this.data.data[0].pending_offline_subscription;
      this.pendingOrders =this.data.data[0].pendingOrders;
      this.newOrders =this.data.data[0].newOrders;
      this.processingOrders =this.data.data[0].processingOrders;
      this.newenquiries =this.data.data[0].new_enquiry;
      this.http.get(this.helper.base_url+'http/get/user/permissions',{ headers: this.headers })

      .subscribe(data => {
        this.user_permissions = JSON.parse(data['_body']);
       //console.log(this.user_permissions);


      });

      this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })

      .subscribe(data => {
        let body = JSON.parse(data['_body']);

        this.checkIfTeacher = body.success;
      if(this.checkIfTeacher == false)
      {
        this.http.get(this.helper.base_url+'http/get/doubt',{ headers: this.headers })

        .subscribe(data => {
          this.topic_vedio = JSON.parse(data['_body']).length;



        });

      }
      else
      {
        this.http.get(this.helper.base_url+'http/get/teacherdoubt',{ headers: this.headers })

          .subscribe(data => {
            this.topic_vedio = JSON.parse(data['_body']).length;;

              //this.dtTrigger.next();


          });
      }
    });
    }
    else
    {
      this.snackbar.open('U Have Been Logged Out', null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
        this.router.navigate(["/login"]);
      //console.log(this.data);
    }
    //console.log(this.data[0]);

    });


  // let user=this.cookie.get('user_id');

      // this.http.get(this.helper.base_url+'http/get/recent_chats')

      // .subscribe(data => {
      //   this.recent_chats = JSON.parse(data['_body']);




      // });
  }
  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
  add_reply_doubt(id,reply){
     this.http.get(this.helper.base_url+'http/add/doubt_reply?id='+id+'&reply='+reply,{ headers: this.headers })
      .subscribe(data => {

        this.refresh() ;
      });
  }
    add_reply_enquiry(id,reply){
     this.http.get(this.helper.base_url+'http/add/enquiry_reply?id='+id+'&reply='+reply,{ headers: this.headers })
      .subscribe(data => {

        this.refresh() ;
      });
  }
   refresh(val=false){

  this.snackbar.open('Success', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["dashboard"]));

 }



}
//
// @Component({
//   selector: 'expired-dialog-box',
//   templateUrl: "expired-dialog-box.html",
// })
// export class ExpiredDialogBox {
//
//   dialog=MAT_DIALOG_DATA;
//   //user=this.cookie.get('user_id');
//   user_token= localStorage.getItem('access_token');
//   private headers: Headers = new Headers({
//   'Accept': 'application/json',
//   'Authorization': "Bearer "+this.user_token
// });
//   constructor(public dialogRef: MatDialogRef<DashboardComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private http:Http,private cookie:CookieService,private snackbar: MatSnackBar,private router:Router,private userIdle: UserIdleService,private helper:HelperService) {
//
//
//   }
//
//
//   ngOnInit() { }
//   restart() {
//     alert("restarting");
//     this.userIdle.resetTimer();
//     this.dialogRef.close();
//   }
//   logout(){
//     this.cookie.removeAll();
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('navigateroute');
//     let body = new FormData();
//
//       //return;
//       body.append('token',this.user_token);
//     this.http.post(this.helper.base_url+'http/logout',body,{ headers: this.headers })
//     .subscribe(data => {
//
//       this.snackbar.open('Logged Out Successfully', null, {
//         duration:5000,
//           extraClasses:'success-snackbar',
//           verticalPosition:'top'
//         });
//      });
//     this.router.navigate(["/login"]);
//     }
// }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts